const currentDate = new Date()
const yearEl = document.querySelector('#year')
yearEl.innerHTML = currentDate.getFullYear().toString()